import { addEventMergeIdIfVariationChangedAndExists } from '../../_common/client/tracking';
import { BaseComponent } from '../../base-component';

export class RecoAlternativeComponent extends BaseComponent {
    public rootSelector = '.js_pdp_reco-alternative';

    public async init(): Promise<void> {
        o_global.eventQBus.on('pattern.carousel.init', (carouselSelector: string) => {
            if (document.querySelector(`${this.rootSelector} ${carouselSelector}`)) {
                o_global.eventQBus.emit('ft5.reco-alternative.loaded');
                if (this.getRootElement().classList.contains('pl_hidden')) {
                    this.trackView({ product_HideReco: 'true' });
                }
            }
        });
    }

    public async onHtmlLoaded(): Promise<void> {
        if (!this.isPresent()) {
            return;
        }
        const variationId = this.getRootElement().dataset.variationId;
        if (!variationId) {
            return;
        }

        // esi will get resolved in head section
        window.o_reco?.api.loadRecommendationsForDetailView(
            addEventMergeIdIfVariationChangedAndExists({
                variationId,
                topTarget: this.rootSelector,
            })
        );
    }
}
